export const OPTION_ALL_VALUE = ""
export const OPTION_ALL_LABEL = "Tất cả"
export const GUIDE_EMPTY = "00000000-0000-0000-0000-000000000000"
export const HOTLINE = "0989565156"
export const COMPANY = "Công ty Cổ phần Thương mại dịch vụ CIS"

export const MUC_BAO_HIEM = [
  {label: "10 triệu đồng/ người/ vụ",value: 10000000},
  {label: "20 triệu đồng/ người/ vụ",value: 20000000},
  {label: "30 triệu đồng/ người/ vụ",value: 30000000},
  {label: "50 triệu đồng/ người/ vụ",value: 50000000},
  {label: "100 triệu đồng/ người/ vụ",value: 100000000},
]

export const FAILBACK =
  "data:image/png;base64,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"

  export const JOB_STATUS = {
    1: { 
      name: "Đang làm việc", 
      color: "#ffffff", // Màu chữ trắng
      background: "rgb(50, 205, 50)"  // Màu nền xanh lá cây nhạt hơn
    },
    2: { 
      name: "Nghỉ tạm thời", 
      color: "#ffffff",  // Màu chữ trắng
      background: "rgb(255, 178, 102)"  // Màu nền cam nhạt hơn
    },
    3: { 
      name: "Đã nghỉ việc", 
      color: "#ffffff",  // Màu chữ trắng
      background: "rgb(240, 128, 128)"  // Màu nền đỏ nhạt hơn
    }
  };
  
export const INFO_BANK = {
  number: "170389666888",
  name: "Công ty Cổ phần Thương mại dịch vụ CIS",
  branch: "Vạn Phúc",
  bank: "Ngân hàng Thương mại cổ phần Sài Gòn Hà Nội (SHB)",
}
  
  

export const STATUS = {
  0: "Chưa duyệt",
  1: "Đã duyệt",
  2: "Không duyệt",
}

export const STATUS_POST = [
  "",
  "#ff7875",
  "#40a9ff",
  "#52c41a",
  "#094ad9",
  "#ff9f40",
]

export const COLOR_STATUS = {
  active: "#0d99ff",
  inactive: "#ff4d4f",
}
export const SYSTEM_KEY = {
  DON_VI_TINH: "DON_VI_TINH",
  DON_VI_HANH_CHINH: "DON_VI_HANH_CHINH",
  LOAI_TAI_LIEU: "LOAI_TAI_LIEU",
  THOI_HAN_BAO_QUAN: "THOI_HAN_BAO_QUAN",
  HOP_SO: "HOP_SO",
  MA_TAI_LIEU: "MA_TAI_LIEU",
  LOAI_BIEN_DONG: "LOAI_BIEN_DONG",
  DOCUMENT_EXTRACTION: "DOCUMENT_EXTRACTION",
  REQUEST_DATA_USAGE_STATUS: "REQUEST_DATA_USAGE_STATUS",
  THOI_HAN_SD: "THOI_HAN_SD",
  CHE_DO_SD: "CHE_DO_SD",
  MUC_DICH_SD_DAT: "MUC_DICH_SD_DAT",
  LINH_VUC: "LINH_VUC",
  STATUS_HO_SO: "STATUS_HO_SO",
  LOAI_DAT: "LOAI_DAT",
  NGON_NGU: "NGON_NGU",
  DO_MAT: "DO_MAT",
  DOSSIER_FORMUSE: "DOSSIER_FORMUSE",
  DOSSIER_PURPOSEUSE: "DOSSIER_PURPOSEUSE",
  DOSSIER_NETWORK: "DOSSIER_NETWORK",
  DOSSIER_FILE_TYPE: "DOSSIER_FILE_TYPE",
  FILE_IMPORT_SAMPLE_TEST_QUESTION: "FILE_IMPORT_SAMPLE_TEST_QUESTION",
  COURSE_STATUS: "COURSE_STATUS",
  COURSE_LEARN_FORM: "COURSE_LEARN_FORM",
  SEX_TYPE: "SEX_TYPE",
  COMMON_STATUS: "COMMON_STATUS",
  ACCOUNT_STATUS: "ACCOUNT_STATUS",
  POST_STATUS: "POST_STATUS",
  SUBMIT_SUPPORT_REQUEST_STATUS: "SUBMIT_SUPPORT_REQUEST_STATUS",
  COURSE_PRICE_TYPE: "COURSE_PRICE_TYPE",
  PRICE_BIDDING: "PRICE_BIDDING",
  QUALITY_SERVICE: "QUALITY_SERVICE",
  SATUS_POST_BIDDING: "SATUS_POST_BIDDING",
  ACADEMIC_LEVEL: "ACADEMIC_LEVEL",
  RANK: "RANK",
  CAREER_LEVEL: "CAREER_LEVEL",
  WAGE_TYPE: "WAGE_TYPE",
  WORKING_FORM: "WORKING_FORM",
  WELFARE: "WELFARE",
  DEGREE: "DEGREE",
  PRESENTATION_LANGUAGE: "PRESENTATION_LANGUAGE",
  FORM_WORKING: "FORM_WORKING",
  NUMBER_STAFF: "NUMBER_STAFF",
  NUMBER_EXP_YEAR: "NUMBER_EXP_YEAR",
  DOSSIER_PROCEDURE_TYPE: "DOSSIER_PROCEDURE_TYPE",
  SUBMISSION_STATUS: "SUBMISSION_STATUS",
  KHO_PHONG: "KHO_PHONG",
  GIA_TU: "GIA_TU",
  NGAN: "NGAN",
  KE: "KE",
  TANG: "TANG",
  TEMPLATE_FILE_IMPORT_POSITION: "TEMPLATE_FILE_IMPORT_POSITION",
  TEMPLATE_FILE_IMPORT_USER: "TEMPLATE_FILE_IMPORT_USER",
  TEMPLATE_FILE_IMPORT_DEPARTMENT: "TEMPLATE_FILE_IMPORT_DEPARTMENT",
  TEMPLATE_FILE_IMPORT_SYSTEM_CATE: "TEMPLATE_FILE_IMPORT_SYSTEM_CATE",
  TEMPLATE_IMPORT_DOSSIER: "TEMPLATE_IMPORT_DOSSIER",
  TEMPLATE_FILE_IMPORT_DOSSIER_FILE: "TEMPLATE_FILE_IMPORT_DOSSIER_FILE",
}
export const ACCOUNT_TYPE_ID = {
  KHACH_HANG_CA_NHAN: 2,
  DOANH_NGHIEP: 3,
  ADMIN: 9,
}

export const ACCOUNT_TYPE_ADMIN = [1, 4, 5, 6, 9]

export const COLOR_STATUS_HO_SO = ["", "#0D9D57", "#CE3135", "#CE3135"]
export const COLORS_CHART_COMMON = ['#0088FE', '#FFBB28', '#00C49F' , '#FF8042', "#FF6666", "#FFCC99" ]

export const RATE_DESC = ["Rất tệ", "Tệ", "Bình thường", "Tốt", "Tuyệt vời"]

export const TYPE_LINK = {
  IMAGE_LINK: 1,
  VIDEO_LINK: 2,
  DOCUMENT_LINK: 3,
  COMPRESSION_LINK: 4,
}

export const ROLES = ['ADMIN_ROLE', 'SALES_DEPARTMENT_HEAD', 'SALES_STAFF', 'SALES_TEAM_LEADER', 'HR_MANAGER', 'LOGISTICS']
export const OBJECT_ROLES = {
  ADMIN_ROLE: { type: 'ADMIN_ROLE', desc: 'Admin' },
  SALES_DEPARTMENT_HEAD: { type: 'SALES_DEPARTMENT_HEAD', desc: 'Trưởng phòng' },
  SALES_TEAM_LEADER: { type: 'SALES_TEAM_LEADER', desc: 'Trưởng nhóm sale' },
  SALES_STAFF: { type: 'SALES_STAFF', desc: 'Nhân viên sale' },
  HR_MANAGER: { type: 'HR_MANAGER', desc: 'Trưởng phòng nhân sự' },
  LOGISTICS: { type: 'LOGISTICS', desc: 'Vận đơn' },
}

export const STATUS_ORDER_VTP = {
  100: { code: 100, bgColor: "#e0e0e0", color: "#505050", title: "Tạo đơn hàng", desc: "VTP đã tạo đơn hàng" },
  104: { code: 104, bgColor: "#f0f9ff", color: "#1d72b8", title: "Giao cho bưu tá", desc: "Giao cho Bưu tá đi nhận" },
  102: { code: 102, bgColor: "#f8d7da", color: "#973535", title: "Đang xử lý", desc: "Đơn hàng chờ xử lý" },
  107: { code: 107, bgColor: "#f8d7da", color: "#721c24", title: "Đối tác yêu cầu hủy", desc: "Đối tác yêu cầu hủy qua API" },
  201: { code: 201, bgColor: "#fdecea", color: "#d9534f", title: "Hủy nhập phiếu gửi", desc: "Hủy nhập phiếu gửi" },
  501: { code: 501, bgColor: "#28a745", color: "#ffffff", title: "Thành công", desc: "Thành công - Đơn hàng đã được giao thành công" },
  502: { code: 502, bgColor: "#fff9db", color: "#856404", title: "Chuyển hoàn bưu cục", desc: "Chuyển hoàn bưu cục gốc" },
  503: { code: 503, bgColor: "#f8d7da", color: "#842029", title: "Hủy", desc: "Hủy - Theo yêu cầu khách hàng" },
  504: { code: 504, bgColor: "#efb2b6", color: "#721c24", title: "Đã trả", desc: "Thành công- Chuyển trả người gửi" },
  505: { code: 505, bgColor: "#fff4cc", color: "#996600", title: "Chờ xử lý", desc: "Tồn - Thông báo chuyển hoàn bưu cục gốc" },
  506: { code: 506, bgColor: "#ffebd7", color: "#995700", title: "Chờ phát lại", desc: "Tồn - Khách hàng nghỉ, không có nhà" },
  507: { code: 507, bgColor: "#ffe6d9", color: "#8b5a00", title: "Tồn", desc: "Tồn - Khách hàng đến bưu cục nhận" },
  508: { code: 508, bgColor: "#d7f9e3", color: "#1c7b35", title: "Phát tiếp", desc: "Đơn vị yêu cầu phát tiếp" },
  509: { code: 509, bgColor: "#e0f3ff", color: "#0056b3", title: "Chuyển tiếp", desc: "Chuyển tiếp bưu cục khác" },
  515: { code: 515, bgColor: "#c8e6c9", color: "#256029", title: "Duyệt hoàn", desc: "Bưu cục phát duyệt hoàn" },
  550: { code: 550, bgColor: "#bbdefb", color: "#0b5b8e", title: "Phát tiếp", desc: "Khách hàng yêu cầu phát tiếp" },
};


export const STATUS_ORDER_VTP_ALL = {
  100: { code: 100, bgColor: "#f5f5f5", color: "#333", title: "Tạo đơn hàng", desc: "Viettelpost xử lý đơn hàng" },
  101: { code: 101, bgColor: "#f5c6cb", color: "#721c24", title: "VTP yêu cầu hủy", desc: "ViettelPost yêu cầu hủy đơn hàng" },
  102: { code: 102, bgColor: "#ffeeba", color: "#856404", title: "Chờ xử lý", desc: "Đơn hàng chờ xử lý" },
  103: { code: 103, bgColor: "#d4edda", color: "#155724", title: "Giao cho bưu cục", desc: "Viettelpost xử lý đơn hàng" },
  104: { code: 104, bgColor: "#d4edda", color: "#155724", title: "Giao cho bưu tá", desc: "Giao cho Bưu tá đi nhận" },
  105: { code: 105, bgColor: "#c3e6cb", color: "#155724", title: "Bưu Tá đã nhận hàng", desc: "Buu Tá đã nhận hàng" },
  106: { code: 106, bgColor: "#d1ecf1", color: "#0c5460", title: "Đối tác yêu cầu lấy lại", desc: "Đối tác yêu cầu lấy lại hàng" },
  107: { code: 107, bgColor: "#d1ecf1", color: "#0c5460", title: "Đối tác yêu cầu hủy", desc: "Đối tác yêu cầu hủy qua API" },
  200: { code: 200, bgColor: "#c3e6cb", color: "#155724", title: "Nhận từ bưu tá", desc: "Nhập doanh thu" },
  201: { code: 201, bgColor: "#f5c6cb", color: "#721c24", title: "Hủy nhập phiếu gửi", desc: "Hủy nhập phiếu gửi" },
  202: { code: 202, bgColor: "#ffeeba", color: "#856404", title: "Sửa phiếu gủi", desc: "Sửa phiếu gủi" },
  300: { code: 300, bgColor: "#d1ecf1", color: "#0c5460", title: "Đóng bảng kê đi", desc: "Vận chuyển đi từ" },
  301: { code: 301, bgColor: "#d1ecf1", color: "#0c5460", title: "Ðóng túi gói", desc: "Vận chuyển đi từ" },
  302: { code: 302, bgColor: "#d1ecf1", color: "#0c5460", title: "Đóng Chuyến thư", desc: "Vận chuyển đi từ" },
  303: { code: 303, bgColor: "#d1ecf1", color: "#0c5460", title: "Đóng tuyến xe", desc: "Vận chuyển đi từ" },
  400: { code: 400, bgColor: "#c3e6cb", color: "#155724", title: "Nhận bảng kê đến", desc: "Nhận tại" },
  401: { code: 401, bgColor: "#c3e6cb", color: "#155724", title: "Nhận Túi gói", desc: "Nhận tại" },
  402: { code: 402, bgColor: "#c3e6cb", color: "#155724", title: "Nhận chuyến thư", desc: "Nhận tại" },
  403: { code: 403, bgColor: "#c3e6cb", color: "#155724", title: "Nhận chuyến xe", desc: "Nhận tại" },
  500: { code: 500, bgColor: "#c3e6cb", color: "#155724", title: "Giao bưu tá đi phát", desc: "Giao buu tá di phát" },
  501: { code: 501, bgColor: "#28a745", color: "#fff", title: "Thành công", desc: "Thành công - Phát thành công" },
  502: { code: 502, bgColor: "#ffc107", color: "#856404", title: "Chuyển hoàn bưu cục gốc", desc: "Chuyển hoàn bưu cục gốc" },
  503: { code: 503, bgColor: "#f5c6cb", color: "#721c24", title: "Hủy", desc: "Hủy - Theo yêu cầu khách hàng" },
  504: { code: 504, bgColor: "#28a745", color: "#fff", title: "Thành công", desc: "Thành công - Chuyển trả người gửi" },
  505: { code: 505, bgColor: "#ffeeba", color: "#856404", title: "Tồn", desc: "Tồn - Thông báo chuyển hoàn bưu cục gốc" },
  506: { code: 506, bgColor: "#ffeeba", color: "#856404", title: "Tồn", desc: "Tồn - Khách hàng nghỉ, không có nhà" },
  507: { code: 507, bgColor: "#ffeeba", color: "#856404", title: "Tồn", desc: "Tồn - Khách hàng đến bưu cục nhận" },
  508: { code: 508, bgColor: "#d4edda", color: "#155724", title: "Phát tiếp", desc: "Đơn vị yêu cầu phát tiếp" },
  509: { code: 509, bgColor: "#d1ecf1", color: "#0c5460", title: "Chuyển tiếp", desc: "Chuyển tiếp bưu cục khác" },
  510: { code: 510, bgColor: "#f5c6cb", color: "#721c24", title: "Hủy", desc: "Hủy phân công phát" },
  515: { code: 515, bgColor: "#c3e6cb", color: "#155724", title: "Duyệt hoàn", desc: "Bưu cục phát duyệt hoàn" },
  550: { code: 550, bgColor: "#28a745", color: "#fff", title: "Phát tiếp", desc: "Khách hàng yêu cầu phát tiếp" },
};

export const CALL_STATE = {
  NEW_NOTIFY: 'NEW_NOTIFY', // incoming call
  UNAVAILABLE: 'UNAVAILABLE',
  INIT: 'INIT',
  RINGING: 'RINGING',
  CONNECTED: 'CONNECTED',
  ENDED: 'ENDED',
  NO_RESPONSE: 'NO_RESPONSE',
  UNKNOWN: 'UNKNOWN',
}

export const CALL_TYPE = {
  CALL_INBOUND: 'CALL_INBOUND',
  CALL_OUTBOUND: 'CALL_OUTBOUND'
}

export const CALL_TYPE_CONST = {
  0: { value: 0, type: "CALL_OUTBOUND", title: 'gọi ra' },
  1: { value: 1, type: "CALL_INBOUND", title: 'gọi vào' }
}

export const CALL_STATUS = {
  0: { status: "received", type: 0, color: "#52c41a", iconName: "callReceived", title: "Cuộc gọi đã nhận" },
  1: { status: "missed", type: 1, color: "#ff4d4f", iconName: "missedCall", title: "Cuộc gọi nhỡ" },
};

export const ZENIFY_CONFIG= {
  CALL_ACTION_REQUEST_ID: 8888,
  CALL_ACTION_RESPONSE_ID: 8888,
  NEW_NOTIFICATION_ID: 100,
  VOICE_ACTIVATED: 6666,
  LOGIN_REQUEST_ID: 2000,
  LOGOUT_REQUEST_ID: 2014,
  LOGIN_RESPOND_ID: 1000,
  LOGOUT_RESPOND_ID: 1003,

  // call flow
  NEW_CALL_RESPOND_ID: 1037,
  ROUTE_TO_QUEUE_RESPONSE_ID: 1126,
  RING_AGENT_RESPOND_ID: 1038,
  AGENT_END_CALL_RESPOND_ID: 1009,
  AGENT_ANSWER_RESPOND_ID: 1039,
  USER_END_CALL_RESPOND_ID: 1011,
  END_CALL_RESPOND_ID: 1012,

  //outcall
  OUT_CALL_REQUEST_ID: 2032,
  OUT_CALL_RESPONSE_ID: 1055,
  OUTCALL_ERROR_RESPONSE_ID: 1083,

  // ngat
  TERMINATE_REQUEST_ID: 2009,
  TERMINATE_RESPOND_ID: 1006,
  TRANSFER_AGENT_TO_AGENT_REQUEST_ID: 2083,
  TRANSFER_AGENT_TO_AGENT_RESPOND_ID: 2084,

  // thay doi trang thai
  CHANGE_AGENT_STATUS_REQUEST: 2013,
  CHANGE_AGENT_STATUS_RESPOND_ID: 2013,

  // hold
  HOLD_REQUEST_ID: 2015,
  UN_HOLD_REQUEST_ID: 2016,
  HOLD_RESPOND_ID: 1029,
  UNHOLD_RESPOND_ID: 1028,

  // mute
  UNMUTE_REQUEST_ID: 2017,
  MUTE_REQUEST_ID: 2018,
  MUTE_RESPOND_ID: 1030,
  UNMUTE_RESPOND_ID: 1031,

  // agent reject
  AGENT_REJECT_CALL_REQUEST_ID: 6000,
  AGENT_REJECT_CALL_RESPONSE_ID: 6000,

  // hanh dong gop chung
  PERFORMING_CALL_ACTION_REQUEST_ID: 2055,
  PERFORMING_CALL_ACTION_RESPONSE_ID: 4026,
  SEARCH_AGENT_REQUEST_ID: 2047,

  // dang ky
  USER_PHONE_REGISTER: 8000,
  USER_PHONE_SELECT: 8003,
  CALL_DETAIL_RESPONSE_ID: 17000,
  CALL_LIST_RESPONSE_ID: 16000,
};

export const BONUS_STATUS = {
  0: { status: 0, title: "Chưa chi trả" },
  1: { status: 1, title: "Đã chi trả" },
}
